import { serializeTheme } from './serialize';
import type { Theme } from './tokens';

type ThemeStyleProps = {
  theme: Theme;
  /** Defaults to `:root`. Pass a selector to scope a theme to a subtree. */
  selector?: string;
};

/**
 * Renders a theme as a stylesheet, so it is in the server-rendered HTML and the
 * first paint is already correct. React owns the element, so a changed or
 * unmounted theme cleans up rather than leaving stale custom properties.
 */
export const ThemeStyle = ({ theme, selector }: ThemeStyleProps) => {
  const css = serializeTheme(theme, selector);
  if (css.length === 0) return null;

  // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml -- serializeTheme allowlists every value; a stylesheet cannot be expressed as children
  return <style dangerouslySetInnerHTML={{ __html: css }} />;
};
